import { useCallback } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';
import { caBannerClick, caBannerClose, caBannerShow, caButtonClick } from 'shared/utils/tracking';

import type { TButtonText } from 'shared/constants/tracking';

export interface IUseLandingTrackingResult {
  trackButtonClick: (buttonText: TButtonText) => void;
  trackBannerShow: () => void;
  trackBannerClose: () => void;
  trackBannerClick: () => void;
}

export const useLandingTracking = (): IUseLandingTrackingResult => {
  const { custom } = useApplicationContext();

  const trackButtonClick = useCallback(
    (buttonText: TButtonText): void => {
      caButtonClick(custom.cianUserId, { buttonText });
    },
    [custom.cianUserId],
  );

  const trackBannerShow = useCallback((): void => {
    caBannerShow(custom.cianUserId);
  }, [custom.cianUserId]);

  const trackBannerClose = useCallback((): void => {
    caBannerClose(custom.cianUserId);
  }, [custom.cianUserId]);

  const trackBannerClick = useCallback((): void => {
    caBannerClick(custom.cianUserId);
  }, [custom.cianUserId]);

  return { trackButtonClick, trackBannerShow, trackBannerClose, trackBannerClick };
};
